import React, { useState } from 'react';
import Icon from '@Theme/natucare/components/Icon/Icon';
import { youtubePlayerPropTypes } from './YoutubePlayerPropTypes';
import * as styles from './YoutubePlayer.module.scss';
const YoutubePlayer = ({
  id,
  buttonLabel,
  alt
}) => {
  const {
    0: isVideoPlaying,
    1: setIsVideoPlaying
  } = useState(false);
  const handleClick = () => {
    setIsVideoPlaying(prevState => !prevState);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, !isVideoPlaying && /*#__PURE__*/React.createElement("img", {
    className: styles.rootImg,
    onClick: handleClick.bind(this, id),
    loading: "lazy",
    alt: alt,
    src: `https://i3.ytimg.com/vi/${id}/maxresdefault.jpg`
  }), isVideoPlaying && /*#__PURE__*/React.createElement("iframe", {
    width: "560",
    height: "315",
    src: `https://www.youtube.com/embed/${id}?autoplay=1`,
    title: "YouTube video player",
    frameBorder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    allowFullScreen: true
  }), !isVideoPlaying && /*#__PURE__*/React.createElement("div", {
    className: styles.rootPlay
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "playVideo",
    classname: styles.rootPlayIcon
  }), buttonLabel));
};
export default YoutubePlayer;